const ADMIN_CREDENTIALS = {
  email: "admin@aitools.com",
  password: "adminaitools",
};

export default ADMIN_CREDENTIALS;
